import { url_base } from '../../config/url';
import axios from 'axios';

export async function getBuildings() {
  try {
    const {
      data: { buildings },
    } = await axios({
      method: 'get',
      url: `${url_base}/api/buildings`,
    });
    return buildings;
  } catch (error) {
    console.error('getBuildings --> Error', error);
    return null;
  }
}

export function getBuildingTowers(buildingId) {
  return axios({
    method: 'get',
    url: `${url_base}/api/buildings/${buildingId}/towers`,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function grantOwnerAccess(buildingId, accessId, token, data) {
  return axios({
    method: 'post',
    url: `${url_base}/api/buildings/${buildingId}/access/${accessId}`,
    headers: {
      Authorization: 'JWT ' + token,
      'Content-Type': 'application/json',
    },
    data,
  });
}

export function getOwnerAccess(buildingId, token) {
  return axios({
    method: 'get',
    url: `${url_base}/api/buildings/${buildingId}/access/`,
    headers: {
      Authorization: 'JWT ' + token,
      'Content-Type': 'application/json',
    },
  });
}

export function getVisitCode(buildingId, code, token) {
  return axios({
    method: 'get',
    url: `${url_base}/api/buildings/${buildingId}/visits/${code}`,
    headers: {
      Authorization: 'JWT ' + token,
      'content-type': 'multipart/form-data',
    },
  });
}

export function updateVisitCode(buildingId, code, token) {
  return axios({
    method: 'put',
    url: `${url_base}/api/buildings/${buildingId}/visits/${code}`,
    headers: {
      Authorization: 'JWT ' + token,
      'content-type': 'multipart/form-data',
    },
  });
}

export async function enableMaintenanceMode(buildingId, durationMinutes) {
  const token = localStorage.getItem('authToken');
  const result = await axios({
    method: 'put',
    url: `${url_base}/api/bluebuilding/buildings/${buildingId}/maintenance`,
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json',
    },
    data: {
      durationMinutes,
    },
  });
  return result?.data;
}

export async function disableMaintenanceMode(buildingId) {
  const token = localStorage.getItem('authToken');
  const result = await axios({
    method: 'delete',
    url: `${url_base}/api/bluebuilding/buildings/${buildingId}/maintenance`,
    headers: {
      Authorization: `JWT ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return result?.data;
}
